import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var initializeUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var isLoggedIn, queryClient, _yield$import, isBuyMarketplaceSupported, mergeCartsExecutionPromise, initializeWishlistExecutionPromise, _yield$import2, getFetchCartOptions, _t;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return window.webShellClient.identity.getIsLoggedIn();
        case 1:
          isLoggedIn = _context2.sent;
          queryClient = window.NikeShop.__INTERNAL_USE__.queryClient;
          _context2.next = 2;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@nike/shop-apis/buy/supported-marketplaces'));
          });
        case 2:
          _yield$import = _context2.sent;
          isBuyMarketplaceSupported = _yield$import.isBuyMarketplaceSupported;
          _context2.next = 3;
          return isBuyMarketplaceSupported();
        case 3:
          if (_context2.sent) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return");
        case 4:
          if (!isLoggedIn) {
            _context2.next = 6;
            break;
          }
          // Start both imports and execute each as soon as it completes
          mergeCartsExecutionPromise = Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./merge-carts'));
          }).then(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
              var mergeCarts;
              return _regeneratorRuntime.wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    mergeCarts = _ref2["default"];
                    _context.next = 1;
                    return mergeCarts({
                      queryClient: queryClient
                    });
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }());
          initializeWishlistExecutionPromise = Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./initialize-wishlist'));
          }).then(function (_ref4) {
            var initializeWishlist = _ref4["default"];
            return initializeWishlist();
          }); // Wait for both operations to complete
          _context2.next = 5;
          return Promise.allSettled([mergeCartsExecutionPromise, initializeWishlistExecutionPromise]);
        case 5:
          _context2.next = 10;
          break;
        case 6:
          _context2.prev = 6;
          _context2.next = 7;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@nike/shop-apis/buy/carts/v2/fetch/get-options'));
          });
        case 7:
          _yield$import2 = _context2.sent;
          getFetchCartOptions = _yield$import2["default"];
          _context2.next = 8;
          return queryClient.prefetchQuery(getFetchCartOptions({
            queryClient: queryClient
          }));
        case 8:
          _context2.next = 10;
          break;
        case 9:
          _context2.prev = 9;
          _t = _context2["catch"](6);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6, 9]]);
  }));
  return function initializeUser() {
    return _ref.apply(this, arguments);
  };
}();
export default initializeUser;